import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../api/auth.api";
import { useAuthStore } from "../store/auth.store";

/**
 * Lands here after the Entra callback redirects with tokens in the URL fragment.
 * Persists tokens to the auth store and redirects to the original destination.
 */
export function PostLogin() {
  const navigate = useNavigate();
  const { setTokens, setUser } = useAuthStore();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const hash = window.location.hash.replace(/^#/, "");
    const params = new URLSearchParams(hash);
    const accessToken = params.get("accessToken");
    const refreshToken = params.get("refreshToken");
    const returnTo = params.get("returnTo") ?? "/";

    if (!accessToken || !refreshToken) {
      navigate("/login", { replace: true });
      return;
    }

    setTokens({ accessToken, refreshToken });

    // Wipe the fragment so tokens don't sit in browser history.
    window.history.replaceState(null, "", window.location.pathname);

    authApi
      .me()
      .then((user) => setUser(user))
      .catch(() => undefined)
      .finally(() => {
        navigate(returnTo, { replace: true });
      });
  }, [navigate, setTokens, setUser]);

  return (
    <div className="login-page">
      <div className="card login-card">
        <p className="muted">Signing you in…</p>
      </div>
    </div>
  );
}
